














import { Component, Vue, Provide } from 'vue-property-decorator'
import { City, defaultCity } from '@app/core/constant/city'
import { namespace } from 'vuex-class'
import searchInput from './components/searchInput/index.vue'
import ProductItem from './components/goodItem/item.vue'
import { List } from 'vant'
import { getSearchResult, getChannelData } from './service/index'
import { getSelectedCity, allowRefreshOrShare } from '@utils/index'

@Component({
  components: {
    searchInput,
    ProductItem,
    [List.name]: List,
  },
})
export default class GrowthSouvenir extends Vue {
  list: any = []
  loading = true
  finished = false
  cityInfo: City = defaultCity
  templateType = 2 //templateType 1：个性化 2：通用
  pageInfo = {
    pafeSize: 10,
    pageStart: 0,
  }
  categoryIds = '' // 品类id
  errormsg = '' //不为空 就实现错误页面

  @Provide()
  pageTrackParams: any = {}

  beforeCreate() {
    this.$setTitle('成长纪念品')
  }

  async created() {
    allowRefreshOrShare(false)
    this.cityInfo = await getSelectedCity()
    await this.getLevel4CategoryId()
    this.onLoad()
  }

  onLoad() {
    // 异步更新数据
    this.getList()
  }

  async getLevel4CategoryId() {
    const { categoryIds } = await getChannelData(this.channelId, this.cityInfo.cityId)
    this.categoryIds = categoryIds
  }

  async getList() {
    const data = {
      cityId: this.citycode,
      distanceSort: false,
      level4CategoryId: this.categoryIds,
      openOption: false,
      saleNumSort: true, // 按照销量进行倒序排列
      start: this.pageInfo.pageStart,
      limit: this.pageInfo.pafeSize,
      tabs: '3',
      type: 3,
    }
    const res = await getSearchResult(data)
    this.loading = false
    if (res && res.code === '1') {
      this.list = [...this.list, ...res.data.cmmdtyInfo.list]
      this.pageInfo.pageStart += this.pageInfo.pafeSize
      if (this.list.length === res.data.cmmdtyInfo.total) {
        this.finished = true
      }
    }
  }

  refresh() {
    this.reset()
    this.onLoad()
  }

  reset() {
    this.pageInfo.pageStart = 0
    this.list = []
  }

  get citycode() {
    return String(this.$route.query.citycode)
  }

  get channelId() {
    return String(this.$route.query.channel)
  }
}
